import Refiner from '@mui/icons-material/Assistant'
import HelpIcon from '@mui/icons-material/Help'
import LiveHelpIcon from '@mui/icons-material/LiveHelp'
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary'
import PhoneIcon from '@mui/icons-material/Phone'
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material'
import I18n from 'i18n-js'
import { useRef, useState } from 'react'
import { makeStyles } from 'tss-react/mui'

import { helpWidget } from '@src/lib/HelpWidget'

import SubmitAnIdeaDialog from '../Tracking/SubmitAnIdeaDialog'
import useTracking from '../Tracking/useTracking'

interface HelpDropDownProps {}

const useStyles = makeStyles()((theme) => ({
  helpContainer: {
    width: 240,
    overflow: 'auto',
  },
}))

const HelpDropDown: React.FC<
  React.PropsWithChildren<HelpDropDownProps>
> = () => {
  const { classes } = useStyles()
  const buttonRef = useRef<HTMLButtonElement>(null)
  const { track } = useTracking()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>()
  const open = Boolean(anchorEl)
  const toggleMenu = (event?: React.MouseEvent<HTMLElement>) => {
    const element = event?.currentTarget
    setAnchorEl(element)
    track({
      event: 'Click',
      data: {
        type: 'Help Menu Toggle',
        showMenu: !!element,
      },
    })
  }
  const openChat = () => {
    helpWidget.open()
    setAnchorEl(null)
  }

  const [isSubmitDialogOpen, setIsSubmitDialogOpen] = useState(false)

  return (
    <>
      <IconButton
        onClick={toggleMenu}
        color="inherit"
        ref={buttonRef}
        size="large"
      >
        <LiveHelpIcon />
      </IconButton>
      <Menu
        id={'help-menu'}
        open={open}
        anchorEl={anchorEl}
        onClose={() => toggleMenu()}
        keepMounted
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          component="a"
          href="https://support.promoboxx.com/"
          target="_blank"
        >
          <ListItemIcon>
            <LocalLibraryIcon />
          </ListItemIcon>
          <Typography>{I18n.t('shared.supportCenter')}</Typography>
        </MenuItem>
        <MenuItem onClick={openChat}>
          <ListItemIcon>
            <HelpIcon />
          </ListItemIcon>
          <Typography>{I18n.t('shared.contact')}</Typography>
        </MenuItem>

        <MenuItem className={classes.helpContainer}>
          <ListItemIcon>
            <Refiner />
          </ListItemIcon>
          <ListItemText
            onClick={() => {
              setIsSubmitDialogOpen(true)
            }}
          >
            {I18n.t('nav.submitAnIdea')}
          </ListItemText>
          <SubmitAnIdeaDialog
            open={isSubmitDialogOpen}
            onClose={() => setIsSubmitDialogOpen(false)}
          />
        </MenuItem>

        <MenuItem
          component="a"
          href={`tel:${I18n.t('shared.promoboxxPhoneNumber')}`}
        >
          <ListItemIcon>
            <PhoneIcon />
          </ListItemIcon>
          <ListItemText
            primary={<Typography>800-380-7502</Typography>}
            secondary={
              <Typography>
                {I18n.t('shared.promoboxxLeaveVoicemail')}
              </Typography>
            }
          />
        </MenuItem>
      </Menu>
    </>
  )
}

export default HelpDropDown
